// extracted by mini-css-extract-plugin
module.exports = {"entitiesLayout":"_3MzcI"};